import { ApiClient } from "./client"
import Vue from "vue"

let client = new ApiClient("/api/")

export default {
  /* Retrouver les guid des questions intéressantes :
  SELECT questions.guid_text, count(answers.guid) as aswers_count, max_chars, event_question_guid
  FROM questions, answers
  WHERE answers.question_guid = questions.guid
  GROUP BY question_guid
  HAVING count(answers.guid) > 21

  Real questions :
  30 chars => 93900E9D-4985-4AC2-8285-792F8CA7437A / 0efe060a-0d39-455f-abd1-2e458d54abfb
  120 chars => AFEA0BF1-7260-4373-B6F4-FB73D05413A9 / 4d32b534-ec1f-4bf3-ac35-ab5d42456985
  240 chars => C250AFF4-7617-4583-A7A6-DA2C65BDBEC1 / fb6ca18c-c9eb-4e88-9a6e-12db173c4176

  Test questions / 1000 answers :
  30 chars => E2E9D562-83E9-3C40-A66C-53DF70D51FFA
  120 chars => 6226A6F8-6544-30A6-B73E-33850684D1DF
  240 chars => 536048AE-C32F-3AF5-A7E2-DA1DBC0F9556

  Test questions / 17 answers :
  30 chars => 93900E9D-4985-4AC2-8285-792F8CA7437A
  120 chars => AFEA0BF1-7260-4373-B6F4-FB73D05413A9
  240 chars => C250AFF4-7617-4583-A7A6-DA2C65BDBEC1
  */
  async getQuestion(guid) {
    try {
      return await client.get("question/" + guid)
    } catch (error) {
      /*Vue.toasted.global.smartq_error({
        message: "impossible de récupérer la question " + guid,
      })*/
      console.log(error)
    }
  },

  async newQuestion(question) {
    try {
      return await client.post("question", question)
    } catch (error) {
      /*Vue.toasted.global.smartq_error({
        message: "impossible de créer la question " + JSON.stringify(question),
      })*/
      console.log(error)
    }
  },

  async updateQuestion(question) {
    try {
      await client.patch("question", question)
    } catch (error) {
      /*Vue.toasted.global.smartq_error({
        message: "impossible de mettre à jour la question " + JSON.stringify(question),
      })*/
    }
  },

  async deleteAllUserLikesAnswer(question_guid) {
    try {
      await client.delete("userLikesAnswer/" + question_guid)
    } catch (error) {
      /*Vue.toasted.global.smartq_error({
        message: "impossible de supprimer les 'likes' de la question " + question_guid,
      })*/
    }
  },
}
